import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { usePaystackPayment } from 'react-paystack';
import { useKorapay, KorapayButton } from 'react-korapay';
import { PaystackProps } from 'react-paystack/dist/types';
import { IoCloseSharp } from 'react-icons/io5';
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { PropsFromRedux } from '.';
import paystack from '../../../../assets/images/PaystackIcon.png';
import korapay from '../../../../assets/images/koraIcon.png';
import AlphaContext from '../../../../context/AlphaContext/AlphaContext';
import {
  formatMoney,
  getRequiredErrorMessage,
} from '../../../../utils/common.utils';
import { BeatLoader } from '../../../Spinners/Spinner';
import { USER } from '../../../../interfaces/auth.interface';
import { isAnEmptyObject } from '../../../../utils';
import { ShipmentContext } from '../../../../context/AlphaContext/AlphaShipmentContext';
import TextInput from '../../../form-controls/TextInput';
import Button from '../../../common/Button';

interface Props extends PropsFromRedux {
  alphaData: any;
  setAlphaData: Function;
}

interface Inputs {
  Payment: 0 | 1 | 2 | null;
}

const paymentTypes = [
  { title: 'Paystack', icon: paystack, id: 1 },
  { title: 'Korapay', icon: korapay, id: 2 },
];

const AlphaPaymentMethod: React.FC<Props> = ({
  hideModal,
  showModal,
  modal,
  user,
  alphaLoginState,
}) => {
  const history = useHistory();
  const { shipmentData, setShipmentData } = useContext(ShipmentContext);
  console.log('MODEAL>>> ', modal);

  const { alphaData, setAlphaData } = useContext(AlphaContext);

  const itemId =
    Object.keys(alphaData)?.length !== 0 &&
    alphaData?.Merchants[0]?.PreShipmentItems[0]?.product_id;

  const totalProductCost = shipmentData?.total_product_cost;
  const grandTotal = shipmentData?.grand_total;
  const discountedShippingFee = shipmentData?.discounted_shipping_fee;
  const trxnRef = shipmentData?.trxnRef;
  const shippingFee =
    shipmentData &&
    shipmentData?.merchants_shipping_fees &&
    shipmentData?.merchants_shipping_fees[0];
  const newShippingFee =
    discountedShippingFee > 0 ? discountedShippingFee : shippingFee;

  const [paymentId, setPaymentId] = useState('');
  const [paymentList, setPaymentList] = useState<any>();
  const [transRef, setTransRef] = useState('');
  const [shipmentLoading, setShipmentLoading] = useState(false);
  const [initiateState, setInitiateState] = useState(false);
  const [click, setClicked] = useState(false);
  const [gateway, setGateway] = useState('');
  const [coupon, setCoupon] = useState('');
  const [couponVerified, setCouponVerified] = useState(false);

  const [paymentGateway, setPaymentGateway] = useState('');

  const [discountedShippingFees, setDiscountedShippingFees] = useState(null);
  const [merchantShippingFees, setMerchantShippingFees] = useState(null);
  const [grandTotalFromAPI, setGrandTotalFromAPI] = useState(null);
  const [verifyLoading, setVerifyLoading] = useState(false);

  const userObj: USER = user?.response?.Object;
  const createRefCode: any = `WA-${Math.floor(
    Math.random() * 1000000000 + 1
  )}-APH`;
  const [errorMsg, setErrorMsg] = useState('');

  const location = useLocation();
  const onSubmit = async (data: Inputs) => {};

  const closeModal = () => {
    hideModal();
  };

  const close = () => {
    hideModal();
    setAlphaData(alphaData);
  };

  const goBack = () => {
    showModal({
      component: 'UserDetails',
      modalProps: {
        contentLabel: 'User Details modal',
      },
    });
    setAlphaData(alphaData);
  };

  React.useEffect(() => {
    setAlphaData(alphaData);
  }, [alphaData]);

  React.useEffect(() => {
    if (!location.pathname.includes('/alpha-product')) {
      setAlphaData(alphaData);
      closeModal();
    }
  }, [alphaData]);

  const schema = yup.object().shape({
    Payment: yup.number().required(getRequiredErrorMessage('Payment')),
  });

  const { handleSubmit, control, errors, reset, watch, register, setValue } =
    useForm<Inputs>({
      resolver: yupResolver(schema),
      defaultValues: {
        Payment: null,
      },
    });

  const PaymentSelected = watch('Payment');

  // PAYSTACK
  const PUBLICKEY_TEST = 'pk_test_c8d41644127cc7a8309b8308d88538e589dbe9b7';

  const paystackConfig: PaystackProps = {
    reference: trxnRef,
    email: alphaData.ReceiverEmail,
    // amount: grandTotal * 100,
    amount: (grandTotalFromAPI || grandTotal) * 100, // Use grandTotalFromAPI if it exists
    metadata: {
      custom_fields: [
        {
          display_name: 'Paid via',
          variable_name: 'paid_via',
          value: 'GIGL-GO WEB ALPHA',
        },
        {
          display_name: 'Mobile Number',
          variable_name: 'mobile_number',
          value: alphaData.ReceiverPhoneNumber,
        },
      ],
    },
    publicKey:
      window.location.hostname === 'localhost'
        ? process.env.REACT_APP_PAYSTACK_ALPHA_PUBKEY_TEST || ''
        : process.env.REACT_APP_PAYSTACK_ALPHA_PUBKEY_PROD || '',
  };

  const initializePaystackPayment = usePaystackPayment(paystackConfig);

  // KORAPAY
  const korapayConfig = {
    // amount: grandTotal,
    amount: grandTotalFromAPI || grandTotal, // Use grandTotalFromAPI if it exists
    customer: {
      name: alphaData?.ReceiverName,
      email: alphaData?.ReceiverEmail,
    },
    narration: 'Alpha payment with korapay',
    public_key:
      window.location.hostname === 'localhost'
        ? process.env.REACT_APP_KORAPAY_ALPHA_KEY_TEST || ''
        : process.env.REACT_APP_KORAPAY_ALPHA_KEY_LIVE || '',
  };

  const handleKorapay = useKorapay(korapayConfig);

  // const paystackPayment = () => {
  //   setClicked(true);
  //   if (gateway) {
  //     if (trxnRef) {
  //       createShipment();
  //     }
  //   }
  // };

  const makePayment = () => {
    if (paymentGateway === 'Paystack') {
      if (trxnRef) {
        createShipment();
      }
    } else if (paymentGateway === 'Korapay') {
      // Handle Korapay payment
      const [handleKorapayFunction] = handleKorapay;
      handleKorapayFunction({
        onSuccess: () => createShipment(),
        onClose: () => {},
      });
    }
  };

  // payment type
  const selectPaymentType = (selected: string) => {
    setGateway(selected); // Update paymentGateway state

    setPaymentGateway(selected); // Update gateway state
    setValue('Payment', selected); // Update value for Korapay
  };
  console.log(gateway);

  // const verifySuccessful = (ref: string) => {
  //   createShipment();
  // };

  React.useEffect(() => {
    if (paymentList) {
      const payObj: any = paymentList.find(
        (list: any) => list.name === 'Paystack'
      );
      /* eslint no-underscore-dangle: 0 */
      setPaymentId(payObj._id);
    }
  });

  const ALPHA_GATEWAY_LIST_TEST =
    'https://dev-order.thealphashops.com/api/v1/gateway/list';
  const ALPHA_GATEWAY_LIST_PROD =
    'https://order.thealphashops.com/api/v1/gateway/list';
  React.useEffect(() => {
    fetch(
      window.location.hostname === 'localhost'
        ? ALPHA_GATEWAY_LIST_TEST
        : ALPHA_GATEWAY_LIST_PROD,
      {
        method: 'get',
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.message == 'Success') {
          setPaymentList(result.results);
        }
      });
  }, []);

  const ALPHA_GUEST_VERIFY_PROD =
    'https://order.thealphashops.com/api/v1/transaction/guest/verify';
  const ALPHA_GUEST_VERIFY_TEST =
    'https://dev-order.thealphashops.com/api/v1/transaction/guest/verify';
  const verifyPayment = (ref: string) => {
    const verifyPayload = {
      trxnRef: trxnRef !== undefined && trxnRef,
    };
    fetch(
      window.location.hostname === 'localhost'
        ? ALPHA_GUEST_VERIFY_TEST
        : ALPHA_GUEST_VERIFY_PROD,
      {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(verifyPayload),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.error === false) {
          closeModal();
          showModal({
            component: 'OrderSuccessful',
            modalProps: {
              contentLabel: 'Order Successful modal',
            },
          });
        }
        if (response.error === true) {
          setErrorMsg(response.message);
        }
      });
  };

  const createShipment = () => {
    setShipmentLoading(true);
    const totalCost = grandTotalFromAPI || grandTotal; // Use grandTotalFromAPI if it exists

    const shipmentPayload = {
      IsHomeDelivery: alphaData.IsHomeDelivery,
      // payment_gateway: '',
      payment_gateway: gateway,

      ShippingFee: newShippingFee,
      device_platform: 'agility_web',
      Merchants: [
        {
          ...alphaData?.Merchants[0],
          user_id: alphaData?.Merchants[0]?.user_id,
          store_id: alphaData?.Merchants[0]?.store_id,
          ShippingFee: newShippingFee,
          DestinationStationId: alphaData.ReceiverStationId,
          DepartureStationId: +alphaData?.Merchants[0]?.SenderStationId,
          LGA: '',
          SenderCity: alphaData?.Merchants[0]?.SenderLocality,
          ReceiverCity: alphaData?.ReceiverAddress,
          CustomerCode: alphaData?.Merchants[0]?.CustomerCode,
          PreShipmentItems: [
            {
              ...alphaData?.Merchants[0]?.PreShipmentItems[0],
              ShippingFee: newShippingFee,
              ItemValue: totalProductCost,
              Value: totalProductCost,
              product_id: itemId,
            },
          ],
        },
      ],
      PaymentType: alphaData.PaymentType,
      PickupOptions: alphaData.PickupOptions,
      ReceiverAddress: alphaData.ReceiverAddress,
      ReceiverEmail: alphaData.ReceiverEmail,
      account_type: 'guest',
      ReceiverLocation: alphaData.ReceiverLocation,
      ReceiverName: alphaData.ReceiverName,
      ReceiverPhoneNumber: alphaData.ReceiverPhoneNumber,
      ReceiverStationId: alphaData.ReceiverStationId,
      // totalCost: grandTotal,
      totalCost,
      trxnRef,
      VehicleType: alphaData.VehicleType.toUpperCase() || 'BIKE',
    };
    console.log(shipmentPayload)

    console.log('Device Platform:', shipmentPayload.device_platform);

    const ALPHA_GUEST_NEW_PROD =
      'https://order.thealphashops.com/api/v1/order/guest/new';
    const ALPHA_GUEST_NEW_TEST =
      'https://dev-order.thealphashops.com/api/v1/order/guest/new';
    fetch(
      window.location.hostname === 'localhost'
        ? ALPHA_GUEST_NEW_TEST
        : ALPHA_GUEST_NEW_PROD,
      {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(shipmentPayload),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setShipmentLoading(false);
        if (data?.error === false || data?.code === 200) {
          // Close the payment modal
          hideModal();

          // Show the AlphaPaymentSuccessful modal
          showModal({
            component: 'AlphaPaymentSuccessful',
            modalProps: {
              contentLabel: 'Alpha Payment Successful Modal',
            },
          });

          const onSuccess = ({ reference }: any) => {
            verifyPayment(reference);
          };

          const onClose = () => {};

          // if (gateway === 'Paystack') {
          //   initializePaystackPayment(onSuccess, onClose);
          //   closeModal();
          //   history.push('/');
          // } else {
          //   closeModal();
          //   history.push('/');
          // }
          // ***
          if (gateway === 'Paystack') {
            initializePaystackPayment(onSuccess, onClose);
            closeModal();
            history.push('/');
          } else if (gateway === 'Korapay') {
            const [handleKorapayFunction] = handleKorapay;
            handleKorapayFunction({
              onSuccess: () => createShipment(),
              onClose: () => {},
            });
          }
        }
      });
  };

  const ALPHA_COUPON_VERIFY_PROD =
    'https://order.thealphashops.com/api/v1/order/guest/shipping_price';
  const ALPHA_COUPON_VERIFY_TEST =
    'https://dev-order.thealphashops.com/api/v1/order/guest/shipping_price';
  const verifyCoupon = () => {
    setVerifyLoading(true);

    const modalObj: any = modal?.modalProps?.contentLabel;
    const payload = { ...modalObj, coupon_code: coupon };
    fetch(
      window.location.hostname === 'localhost'
        ? ALPHA_COUPON_VERIFY_TEST
        : ALPHA_COUPON_VERIFY_PROD,
      {
        method: 'post',
        headers: new Headers({
          Authorization: `Basic ${alphaLoginState?.response?.results?.token}`,
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log('Results', res);
        if (res.message === 'Success' && !res.error) {
          setDiscountedShippingFees(res.results.discounted_shipping_fee);
          setMerchantShippingFees(res.results.merchants_shipping_fees);
          setGrandTotalFromAPI(res.results.grand_total);
          setCouponVerified(true);
        } else {
          console.log('Error: ', res.message);
        }
      })
      .catch((err: Error) => console.log('verify coupon error=-=- ', err))
      .finally(() => {
        setVerifyLoading(false);
      });
  };

  return (
    <div className="relative w-full px-10 bg-white lg:px-20 payment-modal">
      <div className="flex justify-between w-full">
        <div className="flex justify-between my-6 ">
          <Link
            className="hidden font-bold lg:mt-4 lg:inline-flex md:inline-flex lg:mb-0"
            to={{ pathname: '' }}
            onClick={() => {
              goBack();
            }}
          >
            <HiOutlineArrowNarrowLeft className="inline-flex mt-4 mr-3 text-2xl font-bold" />
          </Link>
          <button type="button" aria-label="Close" onClick={close}>
            <IoCloseSharp className="sticky text-2xl cursor-pointer sm:absolute left-full lg:-mt-6 md:-mt-6 sm:left-auto sm:right-5 sm:top-16" />
          </button>
        </div>
      </div>
      <div className="flex items-center justify-center w-full my-2 border-b border-gray-300 ">
        <h3 className="pb-4 text-gray-500">Payment</h3>
      </div>
      <div className="w-full mb-6">
        <h2 className="mb-4 font-medium text-md text-grey-600">
          Choose Payment Method
        </h2>
      </div>

      {/* paystack */}
      <div className="w-full ">
        {paymentTypes.map((item: any) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={item.id} className="w-full flex justify-between my-0 mb-2">
            {/* <button
            type= button
            */}
            <label
              htmlFor={item.id}
              className="w-full flex items-center justify-between cursor-pointer"
              // onClick={() => selectPaymentType(item.title)}
            >
              {/* <div className="flex items-center h-8 w-60"> */}
              <div className="flex items-center h-8 sm:w-80 md:w-96 lg:w-96">
                <img
                  src={item.icon}
                  alt="GIG App"
                  className="w-8 h-full mr-4"
                />
                <span>{item.title}</span>
              </div>

              <div className="flex items-center justify-end w-full px-3">
                {/* <label htmlFor="1" className="flex justify-between w-full px-3"> */}
                <input
                  name="Payment"
                  value={item.id}
                  id={item.id}
                  ref={register}
                  // defaultChecked={true}
                  className="hidden"
                  type="radio"
                  // added the below
                  onChange={() => selectPaymentType(item.title)}
                />
                {/* <span className="inline-flex items-center "> */}
                <button
                  type="button"
                  onClick={() => selectPaymentType(item.title)}
                  className="flex items-center justify-end"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      selectPaymentType(item.title);
                    }
                  }}
                >
                  {gateway === item.title ? (
                    <MdRadioButtonChecked className=" ml-4 text-2xl text-pink-600 right-10 w-6" />
                  ) : (
                    <MdRadioButtonUnchecked
                      className=" ml-4 text-2xl text-gray-400 right-10 w-6"
                      // onClick={() => selectPaymentType(item.title)}
                    />
                  )}
                </button>
                {/* </span> */}

                {/* </label> */}
              </div>
              {/* </button>  */}
            </label>
          </div>
        ))}
      </div>

      <div className="w-full flex items-center gap-4 mt-6">
        <TextInput
          name="coupon"
          value={coupon}
          className="w-full p-2 mr-1 border border-gray-300 rounded"
          id="coupon"
          labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
          label="Coupon"
          type="string"
          wrapperClassName="w-full"
          errorClassName="pt-12 -mt-16  absolute"
          // error={errors['FullName']}
          placeholder=""
          customChange={setCoupon}
        />
        {coupon && (
          <button
            type="button"
            onClick={() => verifyCoupon()}
            className="self-end py-2 px-4 rounded text-sm font-medium flex items-center justify-center text-white bg-black"
          >
            {verifyLoading ? 'Loading...' : 'Verify'}
          </button>
        )}
      </div>

      {alphaData !== undefined && !isAnEmptyObject(alphaData) && (
        <div className="w-full p-2 my-4 border-b border-gray-300">
          <div className="flex justify-between w-full my-2">
            <h5 className="text-gray-400">Product Price</h5>
            <h5 className="font-semibold">₦{totalProductCost}</h5>
          </div>

          {alphaData !== undefined && (
            <div className="flex justify-between w-full my-2">
              <h5 className="text-gray-400">Quantity</h5>
              <h5 className="font-semibold">
                {alphaData?.Merchants[0].PreShipmentItems[0].Quantity}
              </h5>
            </div>
          )}

          <div className="flex justify-between w-full my-2 ">
            <h5 className="text-gray-400">Delivery Fee</h5>
            {/* <div className="flex">
              {discountedShippingFees && (
                <h5 className="font-semibold text-gray-200 line-through">
                  ₦{newShippingFee}
                </h5>
              )}

              <span
                className={`ml-3 font-semibold ${
                  discountedShippingFees
                    ? 'text-gray-200 line-through'
                    : 'text-black'
                }`}
              >
                ₦{newShippingFee}
              </span>

              {discountedShippingFees && (
                <span className="ml-3 font-semibold text-black no-underline">
                  ₦{discountedShippingFees}
                </span>
              )}
              <span className="ml-3 font-semibold text-black no-underline">
                ₦{newShippingFee}
              </span>
            </div> */}

            <div className="flex">
              {discountedShippingFees ? (
                <>
                  <h5 className="font-semibold text-gray-200 line-through">
                    ₦{newShippingFee}
                  </h5>
                  <span className="ml-3 font-semibold text-black no-underline">
                    ₦{discountedShippingFees}
                  </span>
                </>
              ) : (
                <span className="ml-3 font-semibold text-black">
                  ₦{newShippingFee}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="w-full">
        <div className="flex justify-between w-full my-2">
          <h5 className="text-gray-400">Total</h5>
          {/* <h5 className="font-semibold">₦{grandTotal}</h5> */}
          {/* <div className="flex">
            {grandTotalFromAPI && (
              <h5 className="font-semibold text-gray-200 line-through ">
                ₦{grandTotal}
              </h5>
            )}
            <h5
              className={`font-semibold ${
                grandTotalFromAPI ? 'text-gray-200 line-through' : 'text-black'
              }`}
            >
              ₦{grandTotal}
            </h5>
            {grandTotalFromAPI && (
              <h5 className="font-semibold text-black no-underline ml-3 ">
                ₦{grandTotalFromAPI}
              </h5>
            )}
          </div> */}

          <div className="flex">
            {grandTotalFromAPI ? (
              <>
                <h5 className="font-semibold text-gray-200 line-through">
                  ₦{grandTotal}
                </h5>
                <h5 className="font-semibold text-black no-underline ml-3">
                  ₦{grandTotalFromAPI}
                </h5>
              </>
            ) : (
              <h5 className="font-semibold text-black">₦{grandTotal}</h5>
            )}
          </div>
        </div>
      </div>

      {/* <button
        className="w-full py-3 my-6 mt-6 text-sm font-medium text-white bg-black rounded"
        type="button"
        disabled={gateway === '' && true}
        onClick={() => {
          setClicked(true);
          makePayment();
        }}
      >
        {shipmentLoading ? <BeatLoader color="white" /> : 'Make Payment'}
      </button> */}

      <button
        className="w-full py-3 my-6 mt-6 text-sm font-medium text-white bg-black rounded"
        type="button"
        disabled={
          (gateway === '' && true) || (coupon !== '' && !couponVerified)
        }
        onClick={() => {
          setClicked(true);
          makePayment();
        }}
      >
        {shipmentLoading ? <BeatLoader color="white" /> : 'Make Payment'}
      </button>

      {gateway === '' && click === true && (
        <div className="w-full font-semibold text-center text-red-600">
          <p>Select payment method</p>
        </div>
      )}
      <div className="w-full my-6 font-semibold text-center text-red-600">
        <p>{errorMsg}</p>
      </div>
    </div>
  );
};

export default AlphaPaymentMethod;
